import React, { Suspense } from 'react';

import HeroText from 'src/components/common/modules/v1/global-hero/components/hero-text/hero-text';
import HeroImage from 'src/components/common/modules/v1/global-hero/components/hero-image/hero-image';
import HeroColorBar from 'src/components/common/modules/v1/global-hero/components/hero-color-bar/hero-color-bar';
import { CopyrightWithGradientComponent } from 'src/components/common/modules/copyright-with-gradient/code-split/copyright-with-gradient-component';
import HeroBgVideo from 'src/components/common/modules/v1/global-hero/components/hero-bg-video/hero-bg-video';
import HeroFgVideo from 'src/components/common/modules/v1/global-hero/components/hero-fg-video/hero-fg-video';
import HeroLogo from 'src/components/common/modules/v1/global-hero/components/hero-logo/hero-logo';
import HeroOverlayImage from 'src/components/common/modules/v1/global-hero/components/hero-overlay-image/hero-overlay-image';
import HeroGradient from 'src/components/common/modules/v1/global-hero/components/hero-gradient/hero-gradient';
import HeroBreadcrumb from 'src/components/common/modules/v1/global-hero/components/hero-breadcrumb/hero-breadcrumb';
import HeroScrollDownArrow from 'src/components/common/modules/v1/global-hero/components/hero-scroll-down-arrow/hero-scroll-down-arrow';
import HeroSearchWizard from 'src/components/common/modules/v1/global-hero/components/hero-search-wizard/hero-search-wizard';
import { FallBackModule } from 'src/components/common/modules/fallback-module';

// Switch Modules
const switchModule = (lookupObject, expression) => (lookupObject[expression] || lookupObject['default'])();

type HeroSubModulesType = {
  [key: string]: () => any;
};

const heroSubModules: HeroSubModulesType = {
  heroTextModule: () => HeroText,
  heroImageModule: () => HeroImage,
  heroImageCaptionModule: () => CopyrightWithGradientComponent,
  heroColorBarModule: () => HeroColorBar,
  heroBackgroundVideoModule: () => HeroBgVideo,
  heroLogoModule: () => HeroLogo,
  heroOverlayModule: () => HeroOverlayImage,
  heroGardientModule: () => HeroGradient,
  heroBreadcrumbModule: () => HeroBreadcrumb,
  heroForegroundVideoModule: () => HeroFgVideo,
  heroScrollDownArrowModule: () => HeroScrollDownArrow,
  heroSearchWizardModule: () => HeroSearchWizard,
  default: () => FallBackModule,
};

const HeroModuleLoader = (moduleName, moduleProps) => {
  const ModuleComponent = switchModule(heroSubModules, moduleName);
  return (
    <Suspense key={moduleName} fallback={null}>
      <ModuleComponent {...moduleProps} />
    </Suspense>
  );
};
export default HeroModuleLoader;
